import { Icon, styled } from '@mui/material';

import { TimeLineLogTypes } from 'Lib/constants/timeline/TimeLineLogTypes';

export default function TimelineIcons({ logType }) {
    switch (parseInt(logType)) {
        case TimeLineLogTypes.Printed:
            return <TimelineIcon>print</TimelineIcon>;
        case TimeLineLogTypes.Screened:
            return <TimelineIcon>find_in_page</TimelineIcon>;
        case TimeLineLogTypes.Updated:
        case TimeLineLogTypes.Created:
            return <TimelineIcon>location_automation</TimelineIcon>;
        case TimeLineLogTypes.FileAttachmentAdded:
        case TimeLineLogTypes.FileAttachmentRemoved:
        case TimeLineLogTypes.FileAttachmentModified:
            return <TimelineIcon>file_present</TimelineIcon>;
        case TimeLineLogTypes.NoteAdded:
            return <TimelineIcon>task</TimelineIcon>;
        case TimeLineLogTypes.NoteRemoved:
            return <TimelineIcon>scan_delete</TimelineIcon>;
        case TimeLineLogTypes.NoteModified:
            return <TimelineIcon>quick_reference</TimelineIcon>;
        case TimeLineLogTypes.StatusUpdated:
        default:
            <Icon>edit</Icon>;
    }
}

const TimelineIcon = styled(Icon)(({ theme }) => ({
    marginRight: theme.spacing(2)
}));
